<main>
  <div
    class="page-layout"
    data-qa="server-error-page"
    >
    <div class="content">
      <h1>500</h1>
      <div class="main-text">
        <div>
          <div class="heading">
            <div class="icon">
              <app-icon
                icon="information"
                iconSize="48"
              ></app-icon>
            </div>
            <div class="text">Internal Server Error</div>
          </div>
          <p class="description-text">
            The server encountered an error and was unable to complete your request...
          </p>
          <div class="description">
            @if (helpLinkUrl$ | async; as helpLinkUrl) {
              <p class="mt-3 description-text">
                Try refreshing, and if that doesn't work
                <a [href]="helpLinkUrl" target="_blank">contact support</a>.
              </p>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
